"use strict";
import { chainIdToBackendChain } from "constants/chains";
import { COMMON_BASES } from "constants/routing";
import { NATIVE_CHAIN_ID, nativeOnChain } from "constants/tokens";
import { apolloClient } from "graphql/data/apollo/client";
import { gqlTokenToCurrencyInfo } from "graphql/data/types";
import {
  TokenDocument
} from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { isSameAddress } from "utilities/src/addresses";
export async function getCurrency(currencyId, chainId, tokens) {
  const isNative = currencyId === NATIVE_CHAIN_ID || currencyId?.toLowerCase() === "native" || currencyId?.toLowerCase() === "eth";
  if (isNative) {
    return nativeOnChain(chainId);
  }
  const commonBase = chainId ? COMMON_BASES[chainId]?.find((base) => base.currency.isToken && isSameAddress(base.currency.address, currencyId)) : void 0;
  if (commonBase) {
    return commonBase.currency;
  }
  if (tokens) {
    return tokens[chainId]?.[currencyId];
  } else {
    const { data } = await apolloClient.query({
      query: TokenDocument,
      variables: {
        address: currencyId,
        chain: chainIdToBackendChain({ chainId })
      }
    });
    return gqlTokenToCurrencyInfo(data?.token)?.currency;
  }
}
